export const DEFAULT_PRODUCT_AND_STATE_DATA = {
    productKey: "",
    productVersion: 0,
    customerSelectedProductOptions: {},
    studioSelectedProductOptions: {},
    quantity: 0,
    quantityPerSize: undefined,
    mpvId: undefined,
    productName: "",
    productCategory: "",
    locale: "",
    template: undefined,
    owner: undefined,
    documentUrl: undefined,
    productDataLoadAttempted: false,
    productDataLoadSuccessful: false,
    isFullBleed: false,
    mcpSku: undefined,
    mcpVersion: undefined,
    workId: undefined,
    workRevisionId: undefined,
    workName: undefined,
    workLastSaved: undefined
};
//# sourceMappingURL=types.js.map